
  import { Component, Mixins } from "vue-property-decorator";
  import AuthMixin from "../../common/mixins/auth.mixin";
  import { mapState } from "vuex";
  import ValidatedFormMixin from "@/common/mixins/validated-form.mixin";
    
  @Component({
    computed: {
      ...mapState("Auth", ["errorMessage"])
    }
  })
  export default class ResetPassword extends Mixins(AuthMixin, ValidatedFormMixin) {
    loading = false;
    username = "";
  
    errorMessage!: string;
  
    closeModal(): void {
      this.$router.push("/login");
    }
  
    async submit(): Promise<void> {
      await this.$validator.validateAll().then(async (isValid: boolean) => {
        if (isValid) {
          this.loading = true;
          var result = await this.$store.dispatch("Auth/requestPasswordReset", this.username);
          if (result) {
            alert(result);
            this.closeModal();
          }
          this.loading = false;
        }   
      });
    }
  }
